import { useState } from "react";
import { Check, Copy, MessageCircle, Mail, Phone, Globe } from "lucide-react";
import { toast } from "sonner";

export const CHANNELS = {
  whatsapp: { label: "WhatsApp", Icon: MessageCircle },
  email: { label: "Email", Icon: Mail },
  telefono: { label: "Teléfono", Icon: Phone },
  otro: { label: "Otro", Icon: Globe },
};

export const LANGUAGES = [
  "Inglés", "Francés", "Alemán", "Italiano", "Portugués", "Neerlandés",
  "Ruso", "Polaco", "Sueco", "Chino", "Japonés", "Coreano", "Árabe", "Español",
];

export const capitalize = (s = "") => s.charAt(0).toUpperCase() + s.slice(1);

export const daysLeft = (iso) => {
  const ms = new Date(iso).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / 86400000));
};

export function CopyButton({ text, testId, label = "Copiar" }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text || "");
      setDone(true);
      toast.success("Copiado al portapapeles");
      setTimeout(() => setDone(false), 1500);
    } catch {
      toast.error("No se pudo copiar");
    }
  };
  return (
    <button
      type="button"
      onClick={copy}
      disabled={!text}
      data-testid={testId}
      className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest font-semibold px-3 py-1.5 border border-black bg-white hover:bg-black hover:text-white transition-colors disabled:opacity-40"
    >
      {done ? <Check size={13} /> : <Copy size={13} />} {done ? "Copiado" : label}
    </button>
  );
}
